<template>
  <main>
    <div class="breadcrumb">
      <div class="container">
        <ul>
          <li><router-link to="/">HARUMIFLAG</router-link></li>
          <!-- <li><router-link to="/energy">エネルギーマネジメント</router-link></li> -->
          <li><router-link to="/energy">{{ energyList.acf?.page_title }}</router-link></li>
        </ul>
      </div>
    </div>
    <div class="access">
      <div class="container">
        <h2 class="page--title">ENVIRONMENT<span>環境</span></h2>
        <!-- <ul class="access__tab tabs" v-if="!isLoading && 
          energyList.acf?.large_title_1 || energyList.acf?.large_title_2 ||
          energyList.acf?.large_title_3 || energyList.acf?.large_title_4 || 
          energyList.acf?.large_title_5 || energyList.acf?.large_title_6 ||
          energyList.acf?.large_title_7 || energyList.acf?.large_title_8 ||
          energyList.acf?.large_title_9 || energyList.acf?.large_title_10">
          <li v-if="energyList.acf?.large_title_2" class="access__tab__item tab-link" :class="isActive === `${energyList.acf?.large_title_2}` ? 'current' : '' " @click="isActiveF(`${energyList.acf?.large_title_2}`)">
            <a class="tablinks">{{ energyList.acf?.large_title_2 }}</a>
          </li>
          <li v-if="energyList.acf?.large_title_3" class="access__tab__item tab-link" :class="isActive === `${energyList.acf?.large_title_3}` ? 'current' : '' " @click="isActiveF(`${energyList.acf?.large_title_3}`)">
            <a class="tablinks">{{ energyList.acf?.large_title_3 }}</a>
          </li>
          <li v-if="energyList.acf?.large_title_4" class="access__tab__item tab-link" :class="isActive === `${energyList.acf?.large_title_4}` ? 'current' : '' " @click="isActiveF(`${energyList.acf?.large_title_4}`)">
            <a class="tablinks">{{ energyList.acf?.large_title_4 }}</a>
          </li>
          <li v-if="energyList.acf?.large_title_5" class="access__tab__item tab-link" :class="isActive === `${energyList.acf?.large_title_5}` ? 'current' : '' " @click="isActiveF(`${energyList.acf?.large_title_5}`)">
            <a class="tablinks">{{ energyList.acf?.large_title_5 }}</a>
          </li>
          <li v-if="energyList.acf?.large_title_6" class="access__tab__item tab-link" :class="isActive === `${energyList.acf?.large_title_6}` ? 'current' : '' " @click="isActiveF(`${energyList.acf?.large_title_6}`)">
            <a class="tablinks">{{ energyList.acf?.large_title_6 }}</a>
          </li>
          <li v-if="energyList.acf?.large_title_7" class="access__tab__item tab-link" :class="isActive === `${energyList.acf?.large_title_7}` ? 'current' : '' " @click="isActiveF(`${energyList.acf?.large_title_7}`)">
            <a class="tablinks">{{ energyList.acf?.large_title_7 }}</a>
          </li>
          <li v-if="energyList.acf?.large_title_8" class="access__tab__item tab-link" :class="isActive === `${energyList.acf?.large_title_8}` ? 'current' : '' " @click="isActiveF(`${energyList.acf?.large_title_8}`)">
            <a class="tablinks">{{ energyList.acf?.large_title_8 }}</a>
          </li>
          <li v-if="energyList.acf?.large_title_9" class="access__tab__item tab-link" :class="isActive === `${energyList.acf?.large_title_9}` ? 'current' : '' " @click="isActiveF(`${energyList.acf?.large_title_9}`)">
            <a class="tablinks">{{ energyList.acf?.large_title_9 }}</a>
          </li>
          <li v-if="energyList.acf?.large_title_10" class="access__tab__item tab-link" :class="isActive === `${energyList.acf?.large_title_10}` ? 'current' : '' " @click="isActiveF(`${energyList.acf?.large_title_10}`)">
            <a class="tablinks">{{ energyList.acf?.large_title_10 }}</a>
          </li>
        </ul> -->
        <!-- <div style="width: 80%; margin: 0 auto 77px auto;">
          <PuSkeleton v-if="isLoading" :count="1" height="60px"/>
        </div>
        <div style="width: 80%; margin: 0 auto 35px auto;">
          <PuSkeleton v-if="isLoading" :count="1" height="40px"/>
        </div>
        <div style="width: 80%; margin: 0 auto 38px auto;">
          <PuSkeleton v-if="isLoading" :count="1" height="500px"/>
        </div>
        <div style="width: 80%; margin: 0 auto 35px auto;">
          <PuSkeleton v-if="isLoading" :count="1" height="40px"/>
        </div> -->
        <div class="tab-content" 
        :style="[energyList.acf?.medium_title ||  energyList.acf?.medium_subtitle || energyList.acf?.medium_text_1 || energyList.acf?.medium_text_2 ||
            energyList.acf?.small_title_1 || energyList.acf?.small_image_1 || energyList.acf?.small_text_1 ||
            energyList.acf?.small_title_2 || energyList.acf?.small_image_2 || energyList.acf?.small_text_2 ||
            energyList.acf?.small_title_3 || energyList.acf?.small_image_3 || energyList.acf?.small_text_3 ||
            energyList.acf?.small_title_4 || energyList.acf?.small_image_4 || energyList.acf?.small_text_4 ||
            energyList.acf?.small_title_5 || energyList.acf?.small_image_5 || energyList.acf?.small_text_5 ||
            energyList.acf?.small_title_6 || energyList.acf?.small_image_6 || energyList.acf?.small_text_6 ||
            energyList.acf?.small_title_7 || energyList.acf?.small_image_7 || energyList.acf?.small_text_7 ||
            energyList.acf?.small_title_8 || energyList.acf?.small_image_8 || energyList.acf?.small_text_8 ||
            energyList.acf?.small_title_9 || energyList.acf?.small_image_9 || energyList.acf?.small_text_9 ||
            energyList.acf?.small_title_10 || energyList.acf?.small_image_10 || energyList.acf?.small_text_10
      ] ? {'padding-bottom': '100px'} : {'padding-bottom': '0'}">
          <h2 class="access__title" style="text-align: center;" v-if="energyList.acf?.page_title && !isLoading">{{ energyList.acf?.page_title }}</h2>
          <div :id='energyList.acf?.large_title_1' class="access__content content--1 content-custom current" v-if="energyList.acf?.large_title_1 || energyList.acf?.large_text_1 || energyList.acf?.large_image_1">
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 35px;">
              <PuSkeleton style="height: 30px;" :count="1"/>
            </div>
            <div class="img_holder">
              <img
                v-if="energyList.acf?.large_image_1 && !isLoading"
                :src="$func.formatUrl(energyList.acf?.large_image_1)" 
                :alt="energyList.acf?.large_title_1"
              />
            </div>
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 74px;">
              <PuSkeleton style="height: 500px;" :count="1"/>
            </div>
            <h2 v-if="energyList.acf?.large_title_1 && !isLoading">{{ energyList.acf?.large_title_1 }}</h2>
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 35px;">
              <PuSkeleton style="height: 30px;" :count="1"/>
            </div>
            <p v-if="energyList.acf?.large_text_1 && !isLoading" v-html="energyList.acf?.large_text_1"></p>
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 74px;">
              <PuSkeleton style="height: 30px;" :count="1"/>
            </div>
            <div class="link_holder" v-if="energyList.acf?.display_name_1">
              <a :href="energyList.acf?.url_1" :target="energyList.acf?.operation_at_transition_1 === '同一ウィンドウで表示' ? '_self' : '_blank'">
                <span>{{ energyList.acf?.display_name_1 }}</span>
                <img
                  class="icolink"
                  src="@/assets/img/access/svgfile/ico_link_white.svg"
                  alt=""
                />
              </a>
            </div>
          </div>

          <div :id="energyList.acf?.large_title_2" class="access__content content--1 current" v-if="energyList.acf?.large_title_2 || energyList.acf?.large_text_2 || energyList.acf?.large_image_2">
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 35px;">
              <PuSkeleton style="height: 30px;" :count="1"/>
            </div>
            <div class="img_holder">
              <img
                v-if="energyList.acf?.large_image_2 && !isLoading"
                :src="$func.formatUrl(energyList.acf?.large_image_2)" 
                :alt="energyList.acf?.large_title_2"
              />
            </div>
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 74px;">
              <PuSkeleton style="height: 500px;" :count="1"/>
            </div>
            <h2 v-if="energyList.acf?.large_title_2 && !isLoading">{{ energyList.acf?.large_title_2 }}</h2>
            <p v-if="energyList.acf?.large_text_2 && !isLoading" v-html="energyList.acf?.large_text_2"></p>
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 74px;">
              <PuSkeleton style="height: 30px;" :count="1"/>
            </div>
            <div class="link_holder" v-if="energyList.acf?.display_name_2">
              <a :href="energyList.acf?.url_2" :target="energyList.acf?.operation_at_transition_2 === '同一ウィンドウで表示' ? '_self' : '_blank'">
                <span>{{ energyList.acf?.display_name_2 }}</span>
                <img
                  class="icolink"
                  src="@/assets/img/access/svgfile/ico_link_white.svg"
                  alt=""
                />
              </a>
            </div>
          </div>

          <div :id="energyList.acf?.large_title_3" class="access__content content--1 current" v-if="energyList.acf?.large_title_3 || energyList.acf?.large_text_3 || energyList.acf?.large_image_3">
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 35px;">
              <PuSkeleton style="height: 30px;" :count="1"/>
            </div>
            <div class="img_holder">
              <img
                v-if="energyList.acf?.large_image_3 && !isLoading"
                :src="$func.formatUrl(energyList.acf?.large_image_3)" 
                :alt="energyList.acf?.large_title_3"
              />
            </div>
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 74px;">
              <PuSkeleton style="height: 500px;" :count="1"/>
            </div>
            <h2 v-if="energyList.acf?.large_title_3 && !isLoading">{{ energyList.acf?.large_title_3 }}</h2>
            <p v-if="energyList.acf?.large_text_3 && !isLoading" v-html="energyList.acf?.large_text_3"></p>
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 74px;">
              <PuSkeleton style="height: 30px;" :count="1"/>
            </div>
            <div class="link_holder" v-if="energyList.acf?.display_name_3">
              <a :href="energyList.acf?.url_3" :target="energyList.acf?.operation_at_transition_3 === '同一ウィンドウで表示' ? '_self' : '_blank'">
                <span>{{ energyList.acf?.display_name_3 }}</span>
                <img
                  class="icolink"
                  src="@/assets/img/access/svgfile/ico_link_white.svg"
                  alt=""
                />
              </a>
            </div>
          </div>

          <div :id="energyList.acf?.large_title_4" class="access__content content--1 current" v-if="energyList.acf?.large_title_4 || energyList.acf?.large_text_4 || energyList.acf?.large_image_4">
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 35px;">
              <PuSkeleton style="height: 30px;" :count="1"/>
            </div>
            <div class="img_holder">
              <img
                v-if="energyList.acf?.large_image_4 && !isLoading"
                :src="$func.formatUrl(energyList.acf?.large_image_4)" 
                :alt="energyList.acf?.large_title_4"
              />
            </div>
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 74px;">
              <PuSkeleton style="height: 500px;" :count="1"/>
            </div>
            <h2 v-if="energyList.acf?.large_title_4 && !isLoading">{{ energyList.acf?.large_title_4 }}</h2>
            <p v-if="energyList.acf?.large_text_4 && !isLoading" v-html="energyList.acf?.large_text_4"></p>
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 74px;">
              <PuSkeleton style="height: 30px;" :count="1"/>
            </div>
            <div class="link_holder" v-if="energyList.acf?.display_name_4">
              <a :href="energyList.acf?.url_4" :target="energyList.acf?.operation_at_transition_4 === '同一ウィンドウで表示' ? '_self' : '_blank'">
                <span>{{ energyList.acf?.display_name_4 }}</span>
                <img
                  class="icolink"
                  src="@/assets/img/access/svgfile/ico_link_white.svg"
                  alt=""
                />
              </a>
            </div>
          </div>

          <div :id="energyList.acf?.large_title_5" class="access__content content--1 current" v-if="energyList.acf?.large_title_5 || energyList.acf?.large_text_5 || energyList.acf?.large_image_5">
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 35px;">
              <PuSkeleton style="height: 30px;" :count="1"/>
            </div>
            <div class="img_holder">
              <img
                v-if="energyList.acf?.large_image_5 && !isLoading"
                :src="$func.formatUrl(energyList.acf?.large_image_5)" 
                :alt="energyList.acf?.large_title_5"
              />
            </div>
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 74px;">
              <PuSkeleton style="height: 500px;" :count="1"/>
            </div>
            <h2 v-if="energyList.acf?.large_title_5 && !isLoading">{{ energyList.acf?.large_title_5 }}</h2>
            <p v-if="energyList.acf?.large_text_5 && !isLoading" v-html="energyList.acf?.large_text_5"></p>
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 74px;">
              <PuSkeleton style="height: 30px;" :count="1"/>
            </div>
            <div class="link_holder" v-if="energyList.acf?.display_name_5">
              <a :href="energyList.acf?.url_5" :target="energyList.acf?.operation_at_transition_5 === '同一ウィンドウで表示' ? '_self' : '_blank'">
                <span>{{ energyList.acf?.display_name_5 }}</span>
                <img
                  class="icolink"
                  src="@/assets/img/access/svgfile/ico_link_white.svg"
                  alt=""
                />
              </a>
            </div>
          </div>

          <div :id="energyList.acf?.large_title_6" class="access__content content--1 current" v-if="energyList.acf?.large_title_6 || energyList.acf?.large_text_6 || energyList.acf?.large_image_6">
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 35px;">
              <PuSkeleton style="height: 30px;" :count="1"/>
            </div>
            <div class="img_holder">
              <img
                v-if="energyList.acf?.large_image_6 && !isLoading"
                :src="$func.formatUrl(energyList.acf?.large_image_6)" 
                :alt="energyList.acf?.large_title_6"
              />
            </div>
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 74px;">
              <PuSkeleton style="height: 500px;" :count="1"/>
            </div>
            <h2 v-if="energyList.acf?.large_title_6 && !isLoading">{{ energyList.acf?.large_title_6 }}</h2>
            <p v-if="energyList.acf?.large_text_6 && !isLoading" v-html="energyList.acf?.large_text_6"></p>
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 74px;">
              <PuSkeleton style="height: 30px;" :count="1"/>
            </div>
            <div class="link_holder" v-if="energyList.acf?.display_name_6">
              <a :href="energyList.acf?.url_6" :target="energyList.acf?.operation_at_transition_6 === '同一ウィンドウで表示' ? '_self' : '_blank'">
                <span>{{ energyList.acf?.display_name_6 }}</span>
                <img
                  class="icolink"
                  src="@/assets/img/access/svgfile/ico_link_white.svg"
                  alt=""
                />
              </a>
            </div>
          </div>

          <div :id="energyList.acf?.large_title_7" class="access__content content--1 current" v-if="energyList.acf?.large_title_7 || energyList.acf?.large_text_7 || energyList.acf?.large_image_7">
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 35px;">
              <PuSkeleton style="height: 30px;" :count="1"/>
            </div>
            <div class="img_holder">
              <img
                v-if="energyList.acf?.large_image_7 && !isLoading"
                :src="$func.formatUrl(energyList.acf?.large_image_7)" 
                :alt="energyList.acf?.large_title_7"
              />
            </div>
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 74px;">
              <PuSkeleton style="height: 500px;" :count="1"/>
            </div>
            <h2 v-if="energyList.acf?.large_title_7 && !isLoading">{{ energyList.acf?.large_title_7 }}</h2>
            <p v-if="energyList.acf?.large_text_7 && !isLoading" v-html="energyList.acf?.large_text_7"></p>
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 74px;">
              <PuSkeleton style="height: 30px;" :count="1"/>
            </div>
            <div class="link_holder" v-if="energyList.acf?.display_name_7">
              <a :href="energyList.acf?.url_7" :target="energyList.acf?.operation_at_transition_7 === '同一ウィンドウで表示' ? '_self' : '_blank'">
                <span>{{ energyList.acf?.display_name_7 }}</span>
                <img
                  class="icolink"
                  src="@/assets/img/access/svgfile/ico_link_white.svg"
                  alt=""
                />
              </a>
            </div>
          </div>

          <div :id="energyList.acf?.large_title_8" class="access__content content--1 current" v-if="energyList.acf?.large_title_8 || energyList.acf?.large_text_8 || energyList.acf?.large_image_8">
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 35px;">
              <PuSkeleton style="height: 30px;" :count="1"/>
            </div>
            <div class="img_holder">
              <img
                v-if="energyList.acf?.large_image_8 && !isLoading"
                :src="$func.formatUrl(energyList.acf?.large_image_8)" 
                :alt="energyList.acf?.large_title_8"
              />
            </div>
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 74px;">
              <PuSkeleton style="height: 500px;" :count="1"/>
            </div>
            <h2 v-if="energyList.acf?.large_title_8 && !isLoading">{{ energyList.acf?.large_title_8 }}</h2>
            <p v-if="energyList.acf?.large_text_8 && !isLoading" v-html="energyList.acf?.large_text_8"></p>
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 74px;">
              <PuSkeleton style="height: 30px;" :count="1"/>
            </div>
            <div class="link_holder" v-if="energyList.acf?.display_name_8">
              <a :href="energyList.acf?.url_8" :target="energyList.acf?.operation_at_transition_8 === '同一ウィンドウで表示' ? '_self' : '_blank'">
                <span>{{ energyList.acf?.display_name_8 }}</span>
                <img
                  class="icolink"
                  src="@/assets/img/access/svgfile/ico_link_white.svg"
                  alt=""
                />
              </a>
            </div>
          </div>

          <div :id="energyList.acf?.large_title_9" class="access__content content--1 current" v-if="energyList.acf?.large_title_9 || energyList.acf?.large_text_9 || energyList.acf?.large_image_9">
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 35px;">
              <PuSkeleton style="height: 30px;" :count="1"/>
            </div>
            <div class="img_holder">
              <img
                v-if="energyList.acf?.large_image_9 && !isLoading"
                :src="$func.formatUrl(energyList.acf?.large_image_9)" 
                :alt="energyList.acf?.large_title_9"
              />
            </div>
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 74px;">
              <PuSkeleton style="height: 500px;" :count="1"/>
            </div>
            <h2 v-if="energyList.acf?.large_title_9 && !isLoading">{{ energyList.acf?.large_title_9 }}</h2>
            <p v-if="energyList.acf?.large_text_9 && !isLoading" v-html="energyList.acf?.large_text_9"></p>
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 74px;">
              <PuSkeleton style="height: 30px;" :count="1"/>
            </div>
            <div class="link_holder" v-if="energyList.acf?.display_name_9">
              <a :href="energyList.acf?.url_9" :target="energyList.acf?.operation_at_transition_9 === '同一ウィンドウで表示' ? '_self' : '_blank'">
                <span>{{ energyList.acf?.display_name_9 }}</span>
                <img
                  class="icolink"
                  src="@/assets/img/access/svgfile/ico_link_white.svg"
                  alt=""
                />
              </a>
            </div>
          </div>

          <div :id="energyList.acf?.large_title_10" class="access__content content--1 current" v-if="energyList.acf?.large_title_10 || energyList.acf?.large_text_10 || energyList.acf?.large_image_10">
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 35px;">
              <PuSkeleton style="height: 30px;" :count="1"/>
            </div>
            <div class="img_holder">
              <img
                v-if="energyList.acf?.large_image_10 && !isLoading"
                :src="$func.formatUrl(energyList.acf?.large_image_10)" 
                :alt="energyList.acf?.large_title_10"
              />
            </div>
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 74px;">
              <PuSkeleton style="height: 500px;" :count="1"/>
            </div>
            <h2 v-if="energyList.acf?.large_title_10 && !isLoading">{{ energyList.acf?.large_title_10 }}</h2>
            <p v-if="energyList.acf?.large_text_10 && !isLoading" v-html="energyList.acf?.large_text_10"></p>
            <div class="skeleton-parent" v-if="isLoading" style="margin-bottom: 74px;">
              <PuSkeleton style="height: 30px;" :count="1"/>
            </div>
            <div class="link_holder" v-if="energyList.acf?.display_name_10">
              <a :href="energyList.acf?.url_10" :target="energyList.acf?.operation_at_transition_10 === '同一ウィンドウで表示' ? '_self' : '_blank'">
                <span>{{ energyList.acf?.display_name_10 }}</span>
                <img
                  class="icolink"
                  src="@/assets/img/access/svgfile/ico_link_white.svg"
                  alt=""
                />
              </a>
            </div>
          </div>
          <div class="cont-bottom"
            v-if="energyList.acf?.medium_title ||  energyList.acf?.medium_subtitle || energyList.acf?.medium_text_1 || energyList.acf?.medium_text_2 ||
            energyList.acf?.small_title_1 || energyList.acf?.small_image_1 || energyList.acf?.small_text_1 ||
            energyList.acf?.small_title_2 || energyList.acf?.small_image_2 || energyList.acf?.small_text_2 ||
            energyList.acf?.small_title_3 || energyList.acf?.small_image_3 || energyList.acf?.small_text_3 ||
            energyList.acf?.small_title_4 || energyList.acf?.small_image_4 || energyList.acf?.small_text_4 ||
            energyList.acf?.small_title_5 || energyList.acf?.small_image_5 || energyList.acf?.small_text_5 ||
            energyList.acf?.small_title_6 || energyList.acf?.small_image_6 || energyList.acf?.small_text_6 ||
            energyList.acf?.small_title_7 || energyList.acf?.small_image_7 || energyList.acf?.small_text_7 ||
            energyList.acf?.small_title_8 || energyList.acf?.small_image_8 || energyList.acf?.small_text_8 ||
            energyList.acf?.small_title_9 || energyList.acf?.small_image_9 || energyList.acf?.small_text_9 ||
            energyList.acf?.small_title_10 || energyList.acf?.small_image_10 || energyList.acf?.small_text_10
          ">
            <h2 v-if="energyList.acf?.medium_title || energyList.acf?.medium_subtitle">
              {{ energyList.acf?.medium_title}}<span>{{ energyList.acf?.medium_subtitle }}</span>
            </h2>
            <p v-if="energyList.acf?.medium_text_1" v-html="energyList.acf?.medium_text_1"></p>
            <p v-if="energyList.acf?.medium_text_2" v-html="energyList.acf?.medium_text_2"></p>
            <div class="cont__list">
              <div class="cont__list__child" v-if="energyList.acf?.small_title_1 || energyList.acf?.small_image_1 || energyList.acf?.small_text_1">
                <div class="cont__list__child--item">
                  <div class="wrap-img">
                    <img 
                      v-if="energyList.acf?.small_image_1"
                      :src="$func.formatUrl(energyList.acf?.small_image_1)" 
                      :alt="energyList.acf?.small_title_1" />
                  </div>
                </div>
                <div class="cont__list__child--item">
                  <h3 v-if="energyList.acf?.small_title_1">{{ energyList.acf?.small_title_1 }}</h3>
                  <p v-if="energyList.acf?.small_text_1" v-html="energyList.acf?.small_text_1"></p>
                </div>
              </div>

              <div class="cont__list__child"  v-if="energyList.acf?.small_title_2 || energyList.acf?.small_image_2 || energyList.acf?.small_text_2">
                <div class="cont__list__child--item">
                  <div class="wrap-img">
                    <img 
                      v-if="energyList.acf?.small_image_2"
                      :src="$func.formatUrl(energyList.acf?.small_image_2)" 
                      :alt="energyList.acf?.small_title_2" />
                  </div>
                </div>
                <div class="cont__list__child--item">
                  <h3 v-if="energyList.acf?.small_title_2">{{ energyList.acf?.small_title_2 }}</h3>
                  <p v-if="energyList.acf?.small_text_2" v-html="energyList.acf?.small_text_2"></p>
                </div>
              </div>

              <div class="cont__list__child"  v-if="energyList.acf?.small_title_3 || energyList.acf?.small_image_3 || energyList.acf?.small_text_3">
                <div class="cont__list__child--item">
                  <div class="wrap-img">
                    <img 
                      v-if="energyList.acf?.small_image_3"
                      :src="$func.formatUrl(energyList.acf?.small_image_3)" 
                      :alt="energyList.acf?.small_title_3" />
                  </div>
                </div>
                <div class="cont__list__child--item">
                  <h3 v-if="energyList.acf?.small_title_3">{{ energyList.acf?.small_title_3 }}</h3>
                  <p v-if="energyList.acf?.small_text_3" v-html="energyList.acf?.small_text_3"></p>
                </div>
              </div>

              <div class="cont__list__child"  v-if="energyList.acf?.small_title_4 || energyList.acf?.small_image_4 || energyList.acf?.small_text_4">
                <div class="cont__list__child--item">
                  <div class="wrap-img">
                    <img 
                      v-if="energyList.acf?.small_image_4"
                      :src="$func.formatUrl(energyList.acf?.small_image_4)" 
                      :alt="energyList.acf?.small_title_4" />
                  </div>
                </div>
                <div class="cont__list__child--item">
                  <h3 v-if="energyList.acf?.small_title_4">{{ energyList.acf?.small_title_4 }}</h3>
                  <p v-if="energyList.acf?.small_text_4" v-html="energyList.acf?.small_text_4"></p>
                </div>
              </div>

              <div class="cont__list__child"  v-if="energyList.acf?.small_title_5 || energyList.acf?.small_image_5 || energyList.acf?.small_text_5">
                <div class="cont__list__child--item">
                  <div class="wrap-img">
                    <img 
                      v-if="energyList.acf?.small_image_5"
                      :src="$func.formatUrl(energyList.acf?.small_image_5)" 
                      :alt="energyList.acf?.small_title_5" />
                  </div>
                </div>
                <div class="cont__list__child--item">
                  <h3 v-if="energyList.acf?.small_title_5">{{ energyList.acf?.small_title_5 }}</h3>
                  <p v-if="energyList.acf?.small_text_5" v-html="energyList.acf?.small_text_5"></p>
                </div>
              </div>

              <div class="cont__list__child"  v-if="energyList.acf?.small_title_6 || energyList.acf?.small_image_6 || energyList.acf?.small_text_6">
                <div class="cont__list__child--item">
                  <div class="wrap-img">
                    <img 
                      v-if="energyList.acf?.small_image_6"
                      :src="$func.formatUrl(energyList.acf?.small_image_6)" 
                      :alt="energyList.acf?.small_title_6" />
                  </div>
                </div>
                <div class="cont__list__child--item">
                  <h3 v-if="energyList.acf?.small_title_6">{{ energyList.acf?.small_title_6 }}</h3>
                  <p v-if="energyList.acf?.small_text_6" v-html="energyList.acf?.small_text_6"></p>
                </div>
              </div>

              <div class="cont__list__child"  v-if="energyList.acf?.small_title_7 || energyList.acf?.small_image_7 || energyList.acf?.small_text_7">
                <div class="cont__list__child--item">
                  <div class="wrap-img">
                    <img 
                      v-if="energyList.acf?.small_image_7"
                      :src="$func.formatUrl(energyList.acf?.small_image_7)" 
                      :alt="energyList.acf?.small_title_7" />
                  </div>
                </div>
                <div class="cont__list__child--item">
                  <h3 v-if="energyList.acf?.small_title_7">{{ energyList.acf?.small_title_7 }}</h3>
                  <p v-if="energyList.acf?.small_text_7" v-html="energyList.acf?.small_text_7"></p>
                </div>
              </div>

              <div class="cont__list__child"  v-if="energyList.acf?.small_title_8 || energyList.acf?.small_image_8 || energyList.acf?.small_text_8">
                <div class="cont__list__child--item">
                  <div class="wrap-img">
                    <img 
                      v-if="energyList.acf?.small_image_8"
                      :src="$func.formatUrl(energyList.acf?.small_image_8)" 
                      :alt="energyList.acf?.small_title_8" />
                  </div>
                </div>
                <div class="cont__list__child--item">
                  <h3 v-if="energyList.acf?.small_title_8">{{ energyList.acf?.small_title_8 }}</h3>
                  <p v-if="energyList.acf?.small_text_8" v-html="energyList.acf?.small_text_8"></p>
                </div>
              </div>

              <div class="cont__list__child"  v-if="energyList.acf?.small_title_9 || energyList.acf?.small_image_9 || energyList.acf?.small_text_9">
                <div class="cont__list__child--item">
                  <div class="wrap-img">
                    <img 
                      v-if="energyList.acf?.small_image_9"
                      :src="$func.formatUrl(energyList.acf?.small_image_9)" 
                      :alt="energyList.acf?.small_title_9" />
                  </div>
                </div>
                <div class="cont__list__child--item">
                  <h3 v-if="energyList.acf?.small_title_9">{{ energyList.acf?.small_title_9 }}</h3>
                  <p v-if="energyList.acf?.small_text_9" v-html="energyList.acf?.small_text_9"></p>
                </div>
              </div>

              <div class="cont__list__child"  v-if="energyList.acf?.small_title_10 || energyList.acf?.small_image_10 || energyList.acf?.small_text_10">
                <div class="cont__list__child--item">
                  <div class="wrap-img">
                    <img 
                      v-if="energyList.acf?.small_image_10"
                      :src="$func.formatUrl(energyList.acf?.small_image_10)" 
                      :alt="energyList.acf?.small_title_10" />
                  </div>
                </div>
                <div class="cont__list__child--item">
                  <h3 v-if="energyList.acf?.small_title_10">{{ energyList.acf?.small_title_10 }}</h3>
                  <p v-if="energyList.acf?.small_text_10" v-html="energyList.acf?.small_text_10"></p>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import axios from "axios";
import { RouterLink } from "vue-router";
import { getUrl, metaData } from '@/utils/helper';

export default {
  name: "Energy",
  components: {
    EnergyList: () => import("@/components/common/energy/EnergyList.vue"),
  },
  data() {
    return {
      // energyList: CONSTANT.dataEnergyList,
      energyList: {},
      isLoading: true,
      isActive: '',
    };
  },

  computed: {},
  methods: {
    isActiveF(title) {
      this.isActive = title;
      var element_to_scroll_to = document.getElementById(title);
      element_to_scroll_to.scrollIntoView();
    },
  },
  created() {
    this.isLoading = true;
    getUrl(`/energy_management/${process.env.VUE_APP_ID_ENERGY}`)
    .then((response) => {
      this.energyList = response.data;

      metaData(
        `${this.energyList.acf?.page_title ? this.energyList.acf?.page_title : 'エネルギーマネジメント'} | HARUMIFLAGタウンポータル`,
        '中央区晴海・HARUMIFLAGのエネルギーマネジメントのご紹介ページです。',
        'HARUMIFLAGタウンポータル',
        'article'
      )

      this.isLoading = false;
    })
    .catch((e) => {
      console.log(e);
      this.$router.push('/timeout')
    });
  },
};
</script>